import React, { useState } from 'react'
import Login from './Login'
import SignUp from './SignUp'
import '../../css/Account/Account.css'

const AccountButtons = () => {
    const [AuthType, setAuthType] = useState('login')
  return (
    <div className="account-buttons">
        <button onClick={() => setAuthType('login')}>Bejelentkezés</button>
        <button onClick={() => setAuthType('signup')}>Regisztráció</button>
        {AuthType === 'login' ? <Login setAuthType={setAuthType}/> : <SignUp setAuthType={setAuthType}/>}
    </div>
  )
}

export default AccountButtons